import React, { useState, useEffect, useCallback } from 'react';
import { BINGAPIKEY, GOOGLEMAPSAPIKEY } from '../../config';
import axios from 'axios';
import { APIURL } from '../../config';
import GoogleMapReact from 'google-map-react';
import { CircularProgress } from '@mui/material'
import MapMarker from './MapMarker';

const MapsBar = (props) => {
  const [showMap, setShowMap] = useState(!props.hideMap);
  const [companyLocation, setCompanyLocation] = useState(['40.754885', '-73.984396']);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        await axios.get(APIURL + '/company', {
          params: { comp_id: props.user.comp_id },
        }).then(async (response) => {
          let companyData = response?.data[0];
          await axios.get(APIURL + '/maps', {
            params: {
              input:
                companyData.loc_addr_line1 + ' ' +
                companyData.loc_addr_line2 + ' ' +
                companyData.loc_city + ' ' +
                companyData.loc_state + ' ' +
                companyData.loc_zip,
            },
          }).then(async (response) => {
            console.log(response?.data?.predictions[0]?.place_id);
            await axios.get(APIURL + '/maps/details', {
              params: { place_id: response?.data?.predictions[0]?.place_id },
            }).then((response) => {
              if (response?.data?.result?.geometry?.location?.lat && response?.data?.result?.geometry?.location?.lat) {
                setCompanyLocation([
                    response?.data?.result?.geometry?.location?.lat,
                    response?.data?.result?.geometry?.location?.lng,
                ]);
              }
            }).catch((error) => {
                console.error('Error fetching location details:', error);
            });
        }).catch((error) => {
            console.error('Error fetching location data:', error);
        });
    }).catch((error) => {
        console.error('Error fetching company data:', error);
    });
      } catch (error) {
        console.error('Error in fetchData:', error);
      } finally {
        setIsLoading(false);
      }
    };
    
    fetchData();
  }, [props.user.comp_id]);

  const toggleMap = useCallback(() => {
    console.log(props.mapsData);
    setShowMap((prevShowMap) => {
      const newShowMap = !prevShowMap;
      props.toggleMap(newShowMap);
      return newShowMap;
    });

  }, [props]);

  useEffect(() => {
    console.log(props.mapsData)
  }, [props.currentProjectLocation, props.mapsData]);

  return (
    <div style={{ marginBottom: '15px' }}>
      <div
        className="d-flex justify-content-end"
        style={{
          backgroundColor: "#EBF8FF",
          height: "2rem",
          border: "1px solid #3FA7D6",
        }}
      >
        <i
          style={{
            color: "#3FA7D6",
            padding: "1px 1px 3px 3px",
            margin: "5px",
          }}
          onClick={toggleMap}
          className="fas fa-map"
        ></i>
      </div>
      {/* Commented out Bing Maps implementation 
      {showMap && (
        <div className="border border-info" style={{ height: "17rem" }}>
          <ReactBingmaps
            id={"projHome"}
            bingmapKey={BINGAPIKEY}
            center={
              props.currentProjectLocation?.loc_lat && props.currentProjectLocation?.loc_lon
                ? [
                    parseFloat(props.currentProjectLocation?.loc_lat),
                    parseFloat(props.currentProjectLocation?.loc_lon),
                  ]
                : [
                    parseFloat(companyLocation[0]),
                    parseFloat(companyLocation[1]),
                  ]
            }
            infoboxesWithPushPins={props.mapsData}
          ></ReactBingmaps>
        </div>
      )} 
      End of commented Bing Maps */}
      {showMap && isLoading && <div className="border border-info" style={{ height: "17rem", display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        {isLoading && <CircularProgress />}
      </div>}
      {showMap && !isLoading && (
        <div className="border border-info" style={{ height: "17rem" }}>
          {!isLoading && <GoogleMapReact
            bootstrapURLKeys={{ key: GOOGLEMAPSAPIKEY }}
            center={{
              lat: (props.currentProjectLocation?.loc_lat && props.currentProjectLocation?.loc_lon)
                ? parseFloat(props.currentProjectLocation.loc_lat)
                : parseFloat(companyLocation[0]),
              lng: (props.currentProjectLocation?.loc_lat && props.currentProjectLocation?.loc_lon)
                ? parseFloat(props.currentProjectLocation.loc_lon)
                : parseFloat(companyLocation[1])
            }}
            defaultZoom={9}
            options={{
              fullscreenControl: false,
              mapTypeControl: false,
            }}
            onGoogleApiLoaded={({ map, maps }) => {
              if (props.mapsData && props.mapsData.length > 1) {
                const bounds = new maps.LatLngBounds();
                
                props.mapsData.forEach(ele => {
                  const lat = ele?.location ? parseFloat(ele.location[0]) : parseFloat(companyLocation[0]);
                  const lng = ele?.location ? parseFloat(ele.location[1]) : parseFloat(companyLocation[1]);
                  
                  if (!isNaN(lat) && !isNaN(lng)) {
                    bounds.extend(new maps.LatLng(lat, lng));
                  }
                });
                
                map.fitBounds(bounds);
              }
              console.log('Google Maps loaded');
            }}
            yesIWantToUseGoogleMapApiInternals
          >
            {props.mapsData && props.mapsData.length > 0 && props.mapsData.map((ele,index) => (
              <MapMarker
                key={index}
                lat={ele?.location ? parseFloat(ele.location[0]) : parseFloat(companyLocation[0])}
                lng={ele?.location ? parseFloat(ele.location[1]) : parseFloat(companyLocation[0])}
                text={ele?.infoboxOption ? ele.infoboxOption.description : ""}
                taskTitle={ele.infoboxOption ? ele.infoboxOption.title : "Unnamed task"}
                empName={ele.pushPinOption ? ele.pushPinOption.title : ""}
                location={ele?.infoboxOption ? ele.infoboxOption.description : ""}
                onClick={() => {
                  // Handle marker click
                  console.log('Marker clicked: here');
                }}
              />
            )) 
            }
          </GoogleMapReact>}
        </div>)}
    </div>
  );
};

export default MapsBar;